// test1053
(1053 && 0);
